export interface TenantColumn {
          name: string;
          type: string;
          nullable: boolean;
          primary_key: boolean;
        }

        export interface TenantTable {
          name: string;
          columns: TenantColumn[];
        }

        export interface TenantSchema {
          area: string;
          schema: string;
          tables: TenantTable[];
        }

        export const TENANT_SCHEMAS: TenantSchema[] = [
  {
    "area": "Advertising",
    "schema": "ADVERTISING",
    "tables": [
      {
        "name": "linkedin_campaign_performance_report",
        "columns": [
          {
            "name": "start_date_in_utc",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "account_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "currency",
            "type": "varchar(10)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_id",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_status",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_start_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_id",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_objective",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_type",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_status",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_type",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_budget",
            "type": "decimal(18,2)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_start_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_end_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_spent",
            "type": "decimal(18,2)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "impressions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "click_through_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_cpm",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_cpc",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "reactions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "comments",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "shares",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "other_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_social_actions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_engagements",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "engagement_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_impressions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_reactions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_comments",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_shares",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_other_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "post_click_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "view_through_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "conversion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_conversion",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_conversion_value",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "return_on_ad_spend",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_post_click_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_view_through_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "leads",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_forms_opened",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_form_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_lead",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_view_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_25_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_50_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_75_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_completions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "full_screen_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ecpv",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_25_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_50_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_75_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_completions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_full_screen_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "click_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "view_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_click_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_view_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_daily_spend",
            "type": "decimal(18,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_landing_page",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_linkedin_page",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "leads_work_email",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_form_completion_rate_work_email",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_lead_work_email",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "member_follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_member_profile",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "qualified_leads",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_qualified_lead",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_dwell_time_seconds",
            "type": "decimal(18, 8)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "subscriptions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_subscriptions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          }
        ]
      },
      {
        "name": "linkedin_creative_performance_report",
        "columns": [
          {
            "name": "start_date_in_utc",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "account_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "currency",
            "type": "varchar(10)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_id",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_status",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_group_start_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_id",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_objective",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_type",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_status",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_type",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_budget",
            "type": "decimal(18,2)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_start_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_end_date",
            "type": "DATE",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "creative_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ad_id",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "creative_status",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ad_introduction_text",
            "type": "varchar(2000)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ad_headline",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ad_line",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "click_url",
            "type": "varchar(512)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "sponsored_update_type",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_length_seconds",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_spent",
            "type": "decimal(18,2)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "impressions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "click_through_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_cpm",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_cpc",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "reactions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "comments",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "shares",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "other_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_social_actions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_engagements",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "engagement_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_impressions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_reactions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_comments",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_shares",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_other_clicks",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "post_click_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "view_through_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "conversion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_conversion",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "total_conversion_value",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "return_on_ad_spend",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_post_click_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_view_through_conversions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "leads",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_forms_opened",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_form_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_lead",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_view_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_25_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_50_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_views_at_75_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_completions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "video_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "full_screen_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "ecpv",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_25_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_50_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_views_at_75_percent",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_completions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_completion_rate",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_video_full_screen_plays",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "click_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "view_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_click_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_view_event_registrations",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_landing_page",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_linkedin_page",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "leads_work_email",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "lead_form_completion_rate_work_email",
            "type": "decimal(5, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_lead_work_email",
            "type": "decimal(12, 4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "member_follows",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "clicks_to_member_profile",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "qualified_leads",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "cost_per_qualified_lead",
            "type": "decimal(12,4)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "average_dwell_time_seconds",
            "type": "decimal(18, 8)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "subscriptions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "viral_subscriptions",
            "type": "bigint",
            "nullable": true,
            "primary_key": false
          }
        ]
      },
      {
        "name": "test",
        "columns": [
          {
            "name": "id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "name",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "created_at",
            "type": "timestamp",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "is_active",
            "type": "boolean",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "date_added",
            "type": "date",
            "nullable": true,
            "primary_key": false
          }
        ]
      }
    ]
  },
  {
    "area": "Customers",
    "schema": "CUSTOMERS",
    "tables": [
      {
        "name": "customers",
        "columns": [
          {
            "name": "customer_id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "first_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "last_name",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "email",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "phone",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "billing_address",
            "type": "varchar(500)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "shipping_address",
            "type": "varchar(500)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "external_user_id",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          }
        ]
      }
    ]
  },
  {
    "area": "Dashboards",
    "schema": "DASHBOARDS",
    "tables": [
      {
        "name": "sales_overview",
        "columns": [
          {
            "name": "date",
            "type": "date",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "total_sales",
            "type": "decimal(15,2)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "total_profit",
            "type": "decimal(15,2)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "unique_customers",
            "type": "int",
            "nullable": false,
            "primary_key": false
          }
        ]
      }
    ]
  },
  {
    "area": "Products",
    "schema": "PRODUCTS",
    "tables": [
      {
        "name": "products",
        "columns": [
          {
            "name": "product_id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "name",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "category",
            "type": "varchar(100)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "price",
            "type": "decimal(10,2)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "cost_price",
            "type": "decimal(10,2)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "stock_quantity",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "sku",
            "type": "varchar(50)",
            "nullable": false,
            "primary_key": false
          }
        ]
      }
    ]
  },
  {
    "area": "Sales",
    "schema": "SALES",
    "tables": [
      {
        "name": "order_items",
        "columns": [
          {
            "name": "order_id",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "product_id",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "quantity",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "unit_price",
            "type": "decimal(10,2)",
            "nullable": false,
            "primary_key": false
          }
        ]
      },
      {
        "name": "orders",
        "columns": [
          {
            "name": "order_id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "customer_id",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "order_date",
            "type": "timestamp",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "status",
            "type": "varchar(50)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "total_amount",
            "type": "decimal(12,2)",
            "nullable": false,
            "primary_key": false
          }
        ]
      },
      {
        "name": "shipment_tracking",
        "columns": [
          {
            "name": "tracking_id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "shipment_id",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "status",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "location",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "timestamp",
            "type": "timestamp",
            "nullable": true,
            "primary_key": false
          }
        ]
      },
      {
        "name": "shipments",
        "columns": [
          {
            "name": "shipment_id",
            "type": "int",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "order_id",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "tracking_number",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "status",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "shipped_date",
            "type": "timestamp",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "estimated_delivery",
            "type": "date",
            "nullable": true,
            "primary_key": false
          }
        ]
      }
    ]
  },
  {
    "area": "Web Analytics",
    "schema": "WEB_ANALYTICS",
    "tables": [
      {
        "name": "daily_page_stats",
        "columns": [
          {
            "name": "date",
            "type": "date",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "page_url",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "total_views",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "unique_users",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "unique_sessions",
            "type": "int",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "avg_time_on_page",
            "type": "decimal(10,2)",
            "nullable": true,
            "primary_key": false
          }
        ]
      },
      {
        "name": "web_events",
        "columns": [
          {
            "name": "event_id",
            "type": "varchar(36)",
            "nullable": false,
            "primary_key": true
          },
          {
            "name": "event_timestamp",
            "type": "timestamp",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "user_id",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "session_id",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "event_name",
            "type": "varchar(255)",
            "nullable": false,
            "primary_key": false
          },
          {
            "name": "page_url",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "referrer_url",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "device_category",
            "type": "varchar(50)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "country",
            "type": "varchar(10)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_source",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          },
          {
            "name": "campaign_medium",
            "type": "varchar(255)",
            "nullable": true,
            "primary_key": false
          }
        ]
      }
    ]
  }
] as const;
